<template>
  <SearchBar
    v-model:value="value.search"
    @update="emits('update')"
  />
  <FoldableContent
    :image="require('@/images/filter_icon.png')"
    title="Filter"
  >
    <Options
      v-if="deliverableTypes"
      v-model:selection="value.deliverableFilter.types"
      title="Types"
      :options="deliverableTypes"
      @update="emits('update')"
    />
  </FoldableContent>
  <FoldableContent
    :image="require('@/images/order_icon.png')"
    title="Order"
  >
    <Option
      v-if="deliverableOrders"
      v-model:selection="value.order"
      title="Order"
      :options="deliverableOrders"
      @update="emits('update')"
    />
  </FoldableContent>
  <Button
    title="Reset"
    :image="require('@/images/reset_icon.png')"
    @click="emits('reset')"
  />
</template>

<script setup lang="ts">
  import SearchBar from "@/components/search_bar.vue"
  import Option from "@/components/inputs/option.vue"
  import Options from "@/components/inputs/options.vue"
  import FoldableContent from "@/components/foldable_content.vue"
  import Button from "@/components/button.vue"
  import {PropType} from "vue"
  import {DeliverableInput} from "@/endpoints/rutsolve/gql/generated/types"
  
  defineProps({
    deliverableOrders: {
      default: null,
      required: false,
      type: Array<string>
    },
    deliverableTypes: {
      default: null,
      required: false,
      type: Array<string>
    }
  })
  
  const emits = defineEmits(["reset", "update"])
  const value = defineModel("value", {
    default: null,
    required: true,
    type: Object as PropType<DeliverableInput>
  })
</script>
